import Reflux from 'reflux';

export default Reflux.createActions([
  'applyUpcomingFilter',
  'applyPastFilter',
  'applyDeletedFilter',
  'applyAllFilter',
  'updateOwnerFilters',
  'clearOwnerFilters',
  'updateLabelFilters',
  'clearLabelFilters',
]);
